import React, {useEffect, useState} from "react";
import {ReactComponent as TopbarIcons} from "../../../../../../assets/images/phone-simulator/screen-topbar.svg";
import DateUtils from "../../../../../../core/services/date-utils";

const PhoneSimulatorScreenTopbar = () => {
    const [time, setTime] = useState(DateUtils.localNow());

    /**
     * As soon as the component mounts:
     * - creates a timer that would update the current time in seconds
     */
    useEffect(() => {
        const timer = setInterval(() => {
            setTime(DateUtils.localNow());
        }, 1000)
        return () => clearInterval(timer);
    }, [])

    return (
        <>
            <div className={'screen-topbar'}>
                <p>
                    {time.format('hh:mm')}
                </p>
                <TopbarIcons/>
            </div>
        </>
    )
}

export default PhoneSimulatorScreenTopbar;
